(function () {
  var SELECTOR = '[data-wu-line-item-delivery]';

  function nowNL() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });

    return {
      day: { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 }[map.weekday],
      hour: parseInt(map.hour || '0', 10),
      minute: parseInt(map.minute || '0', 10)
    };
  }

  function todayScheduleText() {
    var t = nowNL();

    var schedule = {
      1: { cutoffHour: 20, cutoffMinute: 0, beforeText: 'Morgen in huis', afterText: 'Overmorgen in huis' },
      2: { cutoffHour: 20, cutoffMinute: 0, beforeText: 'Morgen in huis', afterText: 'Overmorgen in huis' },
      3: { cutoffHour: 20, cutoffMinute: 0, beforeText: 'Morgen in huis', afterText: 'Overmorgen in huis' },
      4: { cutoffHour: 20, cutoffMinute: 0, beforeText: 'Morgen in huis', afterText: 'Zaterdag in huis' },
      5: { cutoffHour: 20, cutoffMinute: 0, beforeText: 'Morgen in huis', afterText: 'Maandag verstuurd' },
      6: { cutoffHour: 17, cutoffMinute: 0, beforeText: 'Maandag verstuurd', afterText: 'Maandag verstuurd' },
      0: { cutoffHour: 17, cutoffMinute: 0, beforeText: 'Morgen verstuurd', afterText: 'Morgen verstuurd' }
    };

    var cfg = schedule[t.day];
    if (!cfg) return '';

    var cutoffMinutes = (cfg.cutoffHour * 60) + cfg.cutoffMinute;
    var nowMinutes = (t.hour * 60) + t.minute;

    return nowMinutes < cutoffMinutes ? cfg.beforeText : cfg.afterText;
  }

  function renderNode(root) {
    if (!root) return;

    var textEl = root.querySelector('[data-wu-line-item-delivery-text]');
    if (!textEl) return;

    var tracked = root.getAttribute('data-tracked') === 'true';
    var available = root.getAttribute('data-avail') === 'true';
    var inv = parseInt(root.getAttribute('data-inv') || '0', 10);
    var policy = String(root.getAttribute('data-policy') || '');
    var deliveryMessage = String(root.getAttribute('data-delivery-message') || '').trim();
    var fallbackContinueText = String(root.getAttribute('data-fallback-continue-text') || '').trim();

    var output = '';

    if (tracked && inv > 0) {
      output = todayScheduleText();
    } else if (!tracked && available) {
      output = todayScheduleText();
    } else if (tracked && inv <= 0 && policy === 'continue') {
      output = deliveryMessage || fallbackContinueText;
    } else if (available) {
      output = todayScheduleText();
    }

    textEl.textContent = output || '';
    root.hidden = !output;
  }

  function renderAll() {
    var roots = document.querySelectorAll(SELECTOR);
    if (!roots.length) return;

    roots.forEach(function (root) {
      renderNode(root);
    });
  }

  var scheduled = false;

  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      renderAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender);
  } else {
    scheduleRender();
  }

  document.addEventListener('cart:updated', scheduleRender);
  document.addEventListener('shopify:section:load', scheduleRender);
})();